import ProjectRouteGetter from './route-getters/ProjectRouteGetter';

type RouteGetterContainer = {
  project: typeof ProjectRouteGetter;
};

class RouteGetter {
  static get<T extends keyof RouteGetterContainer>(routeName: T): RouteGetterContainer[T] {
    return this.container[routeName];
  }

  protected static get container(): RouteGetterContainer {
    return {
      project: ProjectRouteGetter,
    };
  }
}

export default RouteGetter;
